<template>
  <div class="ecp-modal-container">
    <div class="ecp-modal">
      <form @submit.prevent="loginByEds" autocomplete="off">
        <h4 class="ecp-modal__heading">{{ $t("eds") }}</h4>
        <a @click="$emit('toggleModal')"
          ><v-icon name="times" scale="1.6" class="ecp-modal__close-icon"
        /></a>
        <div class="ecp-modal__body">
          <div class="input-field">
            <label for="iin" class="input-field__label">ИИН</label>
            <input
              ref="iin"
              type="text"
              class="input-field__input"
              id="iin"
              placeholder=""
            />
          </div>
          <div class="input-field hidden">
            <label for="iin" class="input-field__label">БИН</label>
            <input
              ref="bin"
              type="text"
              class="input-field__input"
              id="bin"
              placeholder=""
            />
          </div>
          <div class="input-field">
            <label for="name" class="input-field__label">{{
              $t("first name and last name")
            }}</label>
            <input
              ref="name"
              type="text"
              class="input-field__input"
              id="name"
              placeholder=""
            />
          </div>
          <div class="input-field">
            <label for="serialNumber" class="input-field__label">{{
              $t("serial number")
            }}</label>
            <input
              readonly
              ref="serialNumber"
              type="text"
              class="input-field__input"
              id="serialNumber"
              placeholder=""
            />
          </div>
          <div class="input-field">
            <label for="validity" class="input-field__label">{{
              $t("validity")
            }}</label>
            <input
              readonly
              ref="validity"
              type="text"
              class="input-field__input"
              id="validity"
              placeholder=""
            />
          </div>
          <div class="input-field">
            <label for="publisherName" class="input-field__label">{{
              $t("publisher name")
            }}</label>
            <input
              readonly
              ref="publisherName"
              type="text"
              class="input-field__input"
              id="publisherName"
              placeholder=""
            />
          </div>
          <div class="input-field">
            <label for="algorithm" class="input-field__label">{{
              $t("algorithm")
            }}</label>
            <input
              readonly
              ref="algorithm"
              type="text"
              class="input-field__input"
              id="algorithm"
              placeholder=""
            />
          </div>
          <div class="input-field">
            <textarea readonly ref="pem" class="hidden" id="pem"></textarea>
            <input
              ref="authorityKeyIdentifier"
              type="hidden"
              id="authorityKeyIdentifier"
              style="display: block"
            />
          </div>
        </div>
        <div class="ecp-modal__footer footer row justify-end">
          <button @click="$emit('toggleModal')" class="button footer__button">
            {{ $t("cancel") }}
          </button>
          <button type="submit" class="button filled footer__button">
            {{ $t("entrance") }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import "vue-awesome/icons";
import Icon from "vue-awesome/components/Icon";
import { mapActions } from "vuex";

export default {
  components: {
    "v-icon": Icon
  },
  data() {
    return {
      isLoading: false,
      error: false
    };
  },
  methods: {
    ...mapActions(["userLogin"]),
    loginByEds: function() {
      this.isLoading = true;
      this.userLogin({
        iin: this.$refs.iin.value,
        bin: this.$refs.bin.value,
        serialNumber: this.$refs.serialNumber.value,
        name: this.$refs.name.value,
        validity: this.$refs.validity.value,
        publisherName: this.$refs.publisherName.value,
        algorithm: this.$refs.algorithm.value,
        pem: this.$refs.pem.value,
        authorityKeyIdentifier: this.$refs.authorityKeyIdentifier.value,
        byEds: true
      })
        .then(() => {
          this.$router.push({ path: "/finance" });
        })
        .catch(() => {
          this.error = true;
          this.isLoading = false;
        });
    },
    toggleEcpModal() {
      this.isEcpModalVisible = !this.isEcpModalVisible;
    }
  }
};
</script>

<style scoped>
.ecp-modal-container {
  position: fixed;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}

.ecp-modal {
  position: relative;
  min-width: 448px;
  padding: 30px 24px;
  color: #222c44;
  background-color: #ffffff;
  border-radius: 15px;
  box-shadow: 0px 4px 25px #0c1220;
}

.ecp-modal__close-icon {
  position: absolute;
  top: 30px;
  right: 24px;
  cursor: pointer;
}

.ecp-modal__heading {
  font-size: 36px;
  font-weight: normal;
}

.ecp-modal__body {
  margin-top: 30px;
}

.input-field {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.input-field:not(:first-child) {
  margin-top: 15px;
}

.input-field__label {
  font-size: 15px;
}

.input-field__input {
  padding: 10px 12px;
  outline: none;
  border: 1px solid #acb5c5;
  border-radius: 5px;
  width: 60%;
}

.ecp-modal__footer {
  margin-top: 30px;
}

.footer__button {
  padding: 15px 25px;
  font-size: 15px;
}

.footer__button:not(:first-child) {
  margin-left: 15px;
}

.footer__button:not(.filled) {
  color: #222c44;
}

.footer__button:not(.filled):hover {
  color: #ffffff;
}
</style>
